import React from 'react';
import { Hero } from '../components/sections/Hero';
import { TrustBar } from '../components/sections/TrustBar';
import { AboutDestaMeet } from '../components/sections/AboutDestaMeet';
import { WhatWeDoForYou } from '../components/sections/WhatWeDoForYou';
import { WhyDestaMeet } from '../components/sections/WhyDestaMeet';
import { RoiStats } from '../components/sections/RoiStats';
import { ProcessTimeline } from '../components/sections/ProcessTimeline';
import { SocialProof } from '../components/sections/SocialProof';
import { CtaSection } from '../components/sections/CtaSection';
export function Home() {
  return <>
      <Hero data-id="element-1369" />
      <TrustBar data-id="element-1370" />
      <AboutDestaMeet data-id="element-1371" />
      <WhatWeDoForYou data-id="element-1372" />
      <WhyDestaMeet data-id="element-1373" />
      <RoiStats data-id="element-1374" />
      <ProcessTimeline data-id="element-1375" />
      <SocialProof data-id="element-1376" />
      <CtaSection data-id="element-1377" />
    </>;
}